import { GetterTree } from 'vuex';
import { ERecipientRole } from '../recipients/types/enums/recipient-role';
import { IDealroomState } from '@/dealroom/store/dealroom.store';
import { RootState } from '@/store/store';
import { IRecipient } from '@/types/Recipient';
import { IDocumentPage } from '@/types/document-page';
import { EnumDocumentType } from '@/enums/DocumentType';

export const getterFirstAddedRecipient = 'firstAddedRecipient';
export const getterSelectedRecipient = 'selectedRecipient';
export const getterRecipients = 'recipients';
export const getterDocumentHasApprover = 'documentHasApprover';
export const getterUploadingFile = 'uploadingFile';
export const getterShowWordMergeModal = 'showWordMergeModal';
export const getterIsTemplate = 'isTemplate';
export const getterConnectFirstRecipient = 'connectFirstRecipient';

export const getters: GetterTree<IDealroomState, RootState> = {
  [getterFirstAddedRecipient](state: IDealroomState): IRecipient {
    if (!state.document || !state.document.recipients || !state.document.recipients.length) {
      return;
    }

    return state.document.recipients.reduce((prev: IRecipient, curr: IRecipient) => {
      return new Date(prev.createdAt) < new Date(curr.createdAt) ? prev : curr;
    });
  },
  [getterSelectedRecipient](state: IDealroomState): IRecipient {
    if (state.document && state.document.recipients && state.selectedRecipient.id) {
      return state.document.recipients.find(
        (recipient: IRecipient) => recipient.id === state.selectedRecipient.id
      );
    }
    return null;
  },
  [getterConnectFirstRecipient](state: IDealroomState): boolean {
    return state.selectedRecipient.connectFirstRecipient;
  },
  [getterRecipients](state: IDealroomState): IRecipient[] {
    if (!state.document || !state.document.recipients || !state.document.recipients.length) {
      return [];
    }
    return state.document.recipients.sort(
      (a: IRecipient, b: IRecipient) => a.orderNum - b.orderNum
    );
  },
  [getterDocumentHasApprover](state: IDealroomState): boolean {
    if (state.document && state.document.recipients && !!state.document.recipients.length) {
      return state.document.recipients.some(
        (recipient: IRecipient) => recipient.role === ERecipientRole.Approver
      );
    }
  },
  [getterUploadingFile](state: IDealroomState): boolean {
    if (!state.document) {
      return false;
    }
    if (!state.document.pages || !state.document.pages.length) {
      return false;
    }
    return state.document.pages.some((page: IDocumentPage) => !!page && page.loading);
  },
  [getterShowWordMergeModal](state: IDealroomState): boolean {
    return state.wordMerge.missing && state.wordMerge.missing.length > 0;
  },
  [getterIsTemplate](state: IDealroomState): boolean {
    if (!state.document) {
      return false;
    }
    return state.document.type === EnumDocumentType.Template;
  },
};
